const initializeBorealProfessionScrollers = (root = document) => {
  root.querySelectorAll('.boreal-home-professions .m-mixed-layout--mobile-scroll').forEach((scroller) => {
    if (scroller.dataset.borealDragReady === 'true') return;
    scroller.dataset.borealDragReady = 'true';

    let pointerId = null;
    let startX = 0;
    let startScrollLeft = 0;
    let dragged = false;
    let suppressClick = false;

    scroller.addEventListener('pointerdown', (event) => {
      if (event.pointerType !== 'mouse' || !window.matchMedia('(max-width: 767px)').matches) return;
      pointerId = event.pointerId;
      startX = event.clientX;
      startScrollLeft = scroller.scrollLeft;
      dragged = false;
      scroller.setPointerCapture(pointerId);
    });

    scroller.addEventListener('pointermove', (event) => {
      if (pointerId !== event.pointerId) return;
      const distance = event.clientX - startX;
      if (Math.abs(distance) > 5) {
        dragged = true;
        scroller.classList.add('is-dragging');
      }
      if (dragged) scroller.scrollLeft = startScrollLeft - distance;
    });

    const finishDrag = (event) => {
      if (pointerId !== event.pointerId) return;
      suppressClick = dragged;
      if (scroller.hasPointerCapture(pointerId)) scroller.releasePointerCapture(pointerId);
      pointerId = null;
      dragged = false;
      scroller.classList.remove('is-dragging');
      window.setTimeout(() => {
        suppressClick = false;
      }, 0);
    };

    scroller.addEventListener('pointerup', finishDrag);
    scroller.addEventListener('pointercancel', finishDrag);
    scroller.addEventListener('click', (event) => {
      if (!suppressClick) return;
      event.preventDefault();
      event.stopPropagation();
    }, true);
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initializeBorealProfessionScrollers());
} else {
  initializeBorealProfessionScrollers();
}

document.addEventListener('shopify:section:load', (event) => initializeBorealProfessionScrollers(event.target));
